@if(corpTitle){
    <div [ngClass]="[
            'corp-control-title',
            'corp-control-title-' + corpSize
            ]"
        [style.width.px]="titleWidth"
        style="z-index:1">

            <div class="absolute h-1/2 w-full" [ngClass]="[corpDisabled ? '' : 'border-b border-b-white dark:border-b-[#0c1427]']"></div>
            <div class="absolute bottom-[0px] h-1/2 w-full" [ngClass]="[corpDisabled ? '' : 'border-t-2 border-t-white dark:border-t-[#0c1427]']"></div>
            <div class="absolute inset-0 ml-1 flex items-center justify-start z-10">
                <span #titleRef class="whitespace-nowrap text-[11px]">{{ corpTitle | translate  }}</span>
            </div>
        
    </div>
}



